import React from "react";
import {
  Box,
  Text,
  Flex,
  Modal,
  Button,
  Divider,
  Spinner,
  useToast,
  ModalBody,
  ModalFooter,
  ModalOverlay,
  ModalContent,
  useDisclosure,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { useShipmentForm } from "context/DHLShipmentFormContext";
import ShipmentConfirmationModal from "./ShipmentConfirmationModal";
import useDropOffCreateShipment from "api/mutations/useDropOffCreateShipment";

const ShipmentSummaryModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const toast = useToast();
  const { formData, updateFormData, setShipmentCreatedData } =
    useShipmentForm();
  const {
    isOpen: isConfirmModalOpen,
    onOpen: onConfirmModalOpen,
    onClose: onConfirmModalClose,
  } = useDisclosure();

  function formatToEndOfDay(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    const options = {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
    };
    const formattedDate = new Intl.DateTimeFormat("en-GB", options).format(
      date
    );
    return `${formattedDate} - End of Day`;
  }

  const { mutate: createShipment, isLoading } = useDropOffCreateShipment({
    onSuccess: (data) => {
      console.log("Shipment created successfully:", data);
      setShipmentCreatedData(data?.data);
      onConfirmModalOpen();
    },
    onError: (error) => {
      toast({
        title: error?.response?.data?.err?.message,
        description: error?.response?.data?.err?.detail,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      onClose();
      console.log("Shipment creation failed:", error?.response?.data?.err);
    },
  });

  const handleShipment = async () => {
    try {
      console.log("Creating shipment with formData:", formData);
      const response = await createShipment(formData);
      console.log("Shipment created:", response);
    } catch (error) {
      toast({
        title: "Network Error",
        description: "Please try again later.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      onClose();
      console.log("Error creating shipment in try/catch:", error?.message);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <ModalOverlay />
      <ModalContent minH={"300px"} minW={"800px"} p={4} borderRadius={"16px"}>
        <ModalBody display={"flex"} flexDirection={"column"} gap={4}>
          <Text
            color={"#000000"}
            fontFamily="PlusJakartaSansSemiBold"
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
          >
            Shipment Summary
          </Text>
          <Divider />
          <Box>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansMedium"
              fontSize={"16px"}
              textTransform={"capitalize"}
            >
              Express Domestic
            </Text>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansRegular"
              fontSize={"12px"}
            >
              {formatToEndOfDay(formData?.dateAndTime)}
            </Text>
          </Box>
          <Box>
            {/* <Flex gap={2} alignItems={"center"}>
              <Text
                color={"#000000"}
                fontFamily="PlusJakartaSansMedium"
                fontSize={"16px"}
                textTransform={"capitalize"}
              >
                Volumetric Weight
              </Text>
              <Text
                color={"#000000"}
                fontFamily="PlusJakartaSansRegular"
                fontSize={"12px"}
              >
                12.8 kg
              </Text>
            </Flex> */}
            <Flex gap={2} alignItems={"center"}>
              <Text
                color={"#000000"}
                fontFamily="PlusJakartaSansMedium"
                fontSize={"16px"}
                textTransform={"capitalize"}
              >
                Total Weight
              </Text>
              <Text
                color={"#000000"}
                fontFamily="PlusJakartaSansRegular"
                fontSize={"12px"}
              >
                {formData?.contentDetails?.packages[0]?.weight} kg
              </Text>
            </Flex>
            {/* <Flex gap={2} alignItems={"center"}>
              <Text
                color={"#000000"}
                fontFamily="PlusJakartaSansMedium"
                fontSize={"16px"}
                textTransform={"capitalize"}
              >
                Chargeable Weight
              </Text>
              <Text
                color={"#000000"}
                fontFamily="PlusJakartaSansRegular"
                fontSize={"12px"}
              >
                13 kg
              </Text>
            </Flex> */}
          </Box>

          <Box>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansMedium"
              fontSize={"16px"}
              textTransform={"capitalize"}
            >
              Terms & Conditions
            </Text>
            <Text
              color={"#000000"}
              fontFamily="PlusJakartaSansRegular"
              fontSize={"12px"}
            >
              By clicking Accept and Continue –{" "}
              <Text
                as="span"
                href="#"
                color="#456EFF"
                textDecoration="underline"
                cursor={"pointer"}
              >
                Terms and Conditions
              </Text>
              , and declare that this shipment does not include any{" "}
              <Text
                as="span"
                href="#"
                color="#456EFF"
                textDecoration="underline"
                cursor={"pointer"}
              >
                Prohibited Items
              </Text>
              .
            </Text>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Flex w={"100%"} justify={"end"} gap={4}>
            <Button
              onClick={() => onClose()}
              width={"148px"}
              borderRadius="12px"
              bg={"none"}
              border={"1px solid #000000"}
              color={"#000000"}
              fontSize={"12px"}
              fontWeight={"500"}
              fontFamily={"PlusJakartaSansMedium"}
              letterSpacing={0.2}
            >
              Cancel
            </Button>
            <Button
              bg="#000000"
              borderRadius="12px"
              color="#FFFFFF"
              size="12px"
              fontFamily="PlusJakartaSansMedium"
              w={"225px"}
              h={"40px"}
              textTransform={"uppercase"}
              onClick={() => {
                handleShipment();
                // navigate("/send-a-bag/dhl/label-print");
              }}
              //   onClick={() => onConfirmModalOpen()}
            >
              {isLoading ? <Spinner /> : "ACCEPT & CONTINUE"}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
      <ShipmentConfirmationModal
        onCloseSummaryModal={onClose}
        onClose={onConfirmModalClose}
        isOpen={isConfirmModalOpen}
      />
    </Modal>
  );
};
export default ShipmentSummaryModal;
